import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faPencil, faCancel, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { PromotionsService } from "src/app/services/vehicle/promotions.service";
import { NotifierService } from "angular-notifier";
import { getEmptyGuid, isEmptyGuid } from "src/app/services/util.service";

@Component({
  selector: "app-promotion-detail",
  templateUrl: "./promotion-detail.component.html",
  styleUrls: ["./promotion-detail.component.css"],
})
export class PromotionDetailComponent implements OnInit {
  faPencil = faPencil;
  faCancel = faCancel;
  faPlus = faPlus;

  mode: string = "Add";
  promotionId: string = getEmptyGuid(); 

  promotionDetail: FormField[] = [
    { type: "text", id: "promotionCode", label: "Promotion Code", required: true, maxLength: 150, value: "" },
    { type: "text", id: "description", label: "Description", required: true, maxLength: 150, value: "" },
    { type: "switch", id: "status", label: "Status", value: false },
  ];

  constructor(
    private promotionsService: PromotionsService,
    private notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.promotionId = params['id'];

      if (!isEmptyGuid(this.promotionId)) {
        this.mode = 'Edit';
        this.loadPromotionDetail();
      }
    });
  }

  private loadPromotionDetail(): void {
    this.promotionsService.getDetail(this.promotionId).subscribe({
      next: (response) => {
        if (response && response.body) {
          const data = response.body;
          this.promotionDetail = [
            { type: "text", id: "promotionCode", label: "Promotion Code", required: true, maxLength: 150, value: data.PromotionCode || "" },
            { type: "text", id: "description", label: "Description", required: true, maxLength: 150, value: data.Description || "" },
            { type: "switch", id: "status", label: "Status", value: data.Status ?? false },
          ];
        } else {
          console.error("Invalid response structure", response);
          this.notifier.notify('error', 'Failed to load promotion details.');
        }
      },
      error: (error: any) => {
        console.error("Error loading promotion detail:", error);
        this.notifier.notify('error', 'Error loading promotion details.');
      }
    });
  }
  
  public onSave(): void {
    if (!this.isFormValid()) {
      this.notifier.notify('warning', 'Please complete all required fields.');
      return;
    }

    const promotionFreeItemId = this.mode === 'Add' 
      ? '00000000-0000-0000-0000-000000000000' 
      : this.promotionId;  
  
    const promotionData = {
      PromotionFreeItemId: promotionFreeItemId,  
      PromotionCode: this.getFieldValue('promotionCode'),
      Description: this.getFieldValue('description'),
      Status: this.getFieldValue('status') === true ? true : false
    };

    this.promotionsService.saveDetails(promotionData).subscribe({
      next: (response) => {
        if (
          (response.code !== undefined && response.code !== 0) ||
          response.statusCode < 200 ||
          response.statusCode >= 300
        ) {
          this.notifier.notify('error', response.message || 'The promotion was not saved.');
          return;
        }

        const successMessage = this.mode === 'Add'
          ? 'Promotion Free Item added successfully.'
          : 'Promotion Free Item updated successfully.';
        this.notifier.notify('success', successMessage);
        this.router.navigate(['../../promotion-free-item'], { relativeTo: this.route }); 
      },
      error: (error: any) => {
        console.error("Error saving promotion:", error);
        this.notifier.notify('error', 'Failed to save promotion. Please try again.');
      }
    });
  }
  

  updateFields(event: { fields: FormField[] }): void {
    this.promotionDetail = event.fields;
  }

  isFormValid(): boolean {
    return this.promotionDetail
      .filter(field => field.required)
      .every(field =>
        field.value !== undefined &&
        field.value !== null &&
        (typeof field.value !== 'string' || field.value.trim() !== '')
      );
  }

  private getFieldValue(id: string): any {
    const field = this.promotionDetail.find(f => f.id === id);
    return field?.value ?? '';
  }

  onCancel(): void {
    this.router.navigate(['../../promotion-free-item'], { relativeTo: this.route });
  }
}
